import Button, { buttonClassNames } from '@components/primitives/Button'
import { IconPrefix } from '@components/primitives/Icon/IconPrefix'
import { classMerge } from '@components/utilities/classMerge'
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'

export const ViewTrialsButton = ({
  source = TrackingSources.LISTING_TABLE_OF_CONTENTS,
}: {
  source?: TrackingSources
}) => {
  const trackViewMoreClick = () =>
    trackEvent(TrackingEvents.VIEW_OTHER_TRIALS_CLICKED, {
      source,
    })
  return (
    <a href='#relatedTrials'>
      <Button
        className={classMerge(
          buttonClassNames.legacy.accent.lightGrey,
          'mt-2 w-full rounded-full',
        )}
        onClick={trackViewMoreClick}
        value={<IconPrefix icon={faEye}>Other Trials</IconPrefix>}
      />
    </a>
  )
}
